import React, { useEffect, useState } from 'react';

import { FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import { FiPhone } from 'react-icons/fi';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';

import {
  Content,
  Footer,
  FooterBackGround,
  BordaTelefone,
  Barra,
} from './styles';
import api from '../../../services/api';

import getResponseErrors from '../../../utils/getResponseErrors';
import { formataCep, formataTelefone } from '../../../utils/funcoes';

import Loading from '../../Loading';
import { Clinica } from '../../../hooks/auth';

export interface IClinicaFormatada extends Clinica {
  CliTelefoneFormatado: string;
  CliTelefone2Formatado: string;
}

type ComponentProps = {
  CliCodigo?: number;
  assinatura?: {
    nome: string;
    especialidade: string;
    documento: string;
    conselho: string;
  };
  rodape?: boolean;
};

const LayoutImpressao: React.FC<ComponentProps> = ({
  CliCodigo,
  assinatura,
  rodape = true,
  children,
}) => {
  const { addToast } = useToast();
  const { imagensClinica } = useClinica();
  const [loading, setLoading] = useState(false);
  const [clinica, setClinica] = useState<IClinicaFormatada>();

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';
  // const rodapeImpressao =
  //   imagensClinica.find(img => img.nome === 'rodapeImpressao')?.arquivo_url ||
  //   '';

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IClinicaFormatada>(
          `/clinicas/${CliCodigo}`,
        );
        const dadosFormatados: IClinicaFormatada = {
          ...response.data,
          CliCEP: formataCep(response.data.CliCEP),
          CliTelefoneFormatado: formataTelefone(response.data.CliTelefone),
          CliTelefone2Formatado: formataTelefone(response.data.CliTelefone2),
        };
        setClinica(dadosFormatados);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Houve um erro ao buscar os dados',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (CliCodigo && rodape) {
      loadDados();
    }
  }, [addToast, CliCodigo, rodape]);

  return (
    <div className="container-fluid p-print-0" style={{ maxWidth: '297mm' }}>
      <Content>
        {loading && <Loading />}
        <div className="text-center pb-1">
          <img
            style={{ width: '228px', marginBottom: '2px' }}
            src={logo}
            alt={clinica?.CliNomeAbreviado || ''}
          />
        </div>
        <Barra />
        <div className="container-fluid px-2">
          <br />
          {React.createElement('div', {}, children)}
        </div>
        {rodape && (
          <Footer>
            {assinatura && (
              <div className="text-center">
                ______________________________________
                <br />
                {assinatura.nome}
                <br />
                {assinatura.especialidade && (
                  <>
                    {assinatura.especialidade} <br />
                  </>
                )}
                {assinatura.documento && (
                  <>
                    {assinatura.conselho} {assinatura.documento} <br />
                  </>
                )}
                <br />
              </div>
            )}

            <FooterBackGround className="row mt-2">
              <div className="col-6" style={{ borderRight: '5px solid #fff' }}>
                <div className="p-2 text-white">
                  <h2>{clinica?.CliNomeAbreviado}</h2>
                  <p>
                    {clinica?.CliEndereco}, {clinica?.CliNumero}{' '}
                    {clinica?.CliComplemento}, {clinica?.CliBairro}
                    <br />
                    {clinica?.CliCidade}/{clinica?.CliUF} - {clinica?.CliCEP}
                  </p>
                  <div className="d-flex align-items-center">
                    {clinica?.CliTelefoneFormatado && (
                      <>
                        <BordaTelefone>
                          <FiPhone size={14} />
                        </BordaTelefone>
                        <span className="pl-1 mr-3">
                          {clinica.CliTelefoneFormatado}
                        </span>
                      </>
                    )}
                    {clinica?.CliTelefone2Formatado && (
                      <>
                        <FaWhatsapp size={22} />
                        <span className="pl-1">
                          {clinica.CliTelefone2Formatado}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 text-white">
                  <div>
                    {clinica?.CliFacebook && (
                      <>
                        <FaFacebook size={22} /> /{clinica?.CliFacebook}
                      </>
                    )}
                    <br />
                    {clinica?.CliInstagram && (
                      <>
                        <FaInstagram size={22} /> /{clinica?.CliInstagram}
                      </>
                    )}
                    <br />
                    <br />
                    {clinica?.CliSite && (
                      <span style={{ fontSize: '1.3rem' }}>
                        {clinica.CliSite}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </FooterBackGround>
          </Footer>
        )}
      </Content>
    </div>
  );
};

export default LayoutImpressao;
